// components/Events/DebuffAppliedEvent.tsx

import React, { useContext } from 'react';
import './DebuffAppliedEvent.css';
import { BaseRendererProps } from './eventRenderers';
import { getUniversalSourceIcon } from './StatChangeEvent';
import GameAssetsContext from '../../../../../../context/GameAssetContext';
import debuffImages from './Images/debuffImages';

const DebuffAppliedEvent: React.FC<BaseRendererProps> = ({ log }) => {
  const { gameWideAssets, championsAssets } = useContext(GameAssetsContext);
  const details = log.details;
  const debuffName = details.debuffName;

  // Try to use the universal image fetcher first
  let debuffIcon = null;
  
  if (details.sourceType && details.attackerName) {
    // Use universal image fetcher for ability-based debuffs
    debuffIcon = getUniversalSourceIcon(
      {
        sourceType: details.sourceType,
        imageState: log.imageState,
        sourceName: details.source,
        championName: details.attackerName,
        abilityKey: log.imageState,
      },
      gameWideAssets,
      championsAssets
    );
  }

  // Fallback to debuffImages if universal fetcher doesn't work
  if (!debuffIcon) {
    const debuffImageUrl = debuffImages[debuffName];
    if (debuffImageUrl) {
      debuffIcon = (
        <img
          src={debuffImageUrl}
          alt={debuffName}
          className="debuff-icon"
          title={debuffName}
        />
      );
    } else {
      debuffIcon = <span className="debuff-name">{debuffName}</span>;
    }
  }

  return (
    <div className="debuff-applied-event">
      <div className="debuff-icon-wrapper">
        {debuffIcon}
      </div>
    </div>
  );
};

export default DebuffAppliedEvent;
